import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../chunks/tslib.es6.js";
import { flatten as r } from "../core/arrayUtils.js";
import { isSome as s } from "../core/maybe.js";
import { eachAlwaysValues as i } from "../core/promiseUtils.js";
import "../core/Logger.js";
import "../core/accessorSupport/ensureType.js";
import "../core/has.js";
import "../core/accessorSupport/set.js";
import { subclass as p } from "../core/accessorSupport/decorators/subclass.js";

var a = function a(_a3) {
  var t = /*#__PURE__*/function (_a) {
    _inherits(t, _a);

    var _super = _createSuper(t);

    function t() {
      _classCallCheck(this, t);

      return _super.apply(this, arguments);
    }

    _createClass(t, [{
      key: "fetchPopupFeatures",
      value: function () {
        var _fetchPopupFeatures = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, s) {
          var _yield$this$_prepareF, p, a, _t, o, c, n, l;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return this.when();

                case 2:
                  _context.next = 4;
                  return this._prepareFetchPopupFeatures(e, s);

                case 4:
                  _yield$this$_prepareF = _context.sent;
                  p = _yield$this$_prepareF.location;
                  a = _yield$this$_prepareF.queryArea;
                  _t = _yield$this$_prepareF.layerViewsAndGraphics;
                  o = _yield$this$_prepareF.clientOnlyGraphics;
                  c = Promise.resolve(o);
                  n = this._queryLayerPopupFeatures(a, _t, s);
                  l = n.map(function (e) {
                    return e.promise;
                  });
                  return _context.abrupt("return", {
                    location: p,
                    clientOnlyGraphics: o,
                    allGraphicsPromise: i([c].concat(_toConsumableArray(l))).then(r),
                    promisesPerLayerView: n
                  });

                case 13:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function fetchPopupFeatures(_x, _x2) {
          return _fetchPopupFeatures.apply(this, arguments);
        }

        return fetchPopupFeatures;
      }()
    }, {
      key: "_queryLayerPopupFeatures",
      value: function _queryLayerPopupFeatures(e, r, i) {
        return r.map(function (_ref) {
          var r = _ref.layerView,
              p = _ref.graphics;

          var a = {
            clientGraphics: p,
            event: s(i) ? i.event : null,
            signal: s(i) ? i.signal : null,
            defaultPopupTemplateEnabled: !!s(i) && !!i.defaultPopupTemplateEnabled
          },
              _t2 = r.fetchPopupFeatures(e, a);

          return {
            layerView: r,
            promise: _t2
          };
        });
      }
    }, {
      key: "_isValidPopupGraphic",
      value: function _isValidPopupGraphic(e, r) {
        return e && !!e.getEffectivePopupTemplate(s(r) && r.defaultPopupTemplateEnabled);
      }
    }, {
      key: "_prepareFetchPopupFeatures",
      value: function () {
        var _prepareFetchPopupFeatures2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e, r) {
          var _yield$this$_popupHit, s, i, p, a, _this$_graphicsPerFet, _t3, o;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return this._popupHitTestGraphics(e, r);

                case 2:
                  _yield$this$_popupHit = _context2.sent;
                  s = _yield$this$_popupHit.clientGraphics;
                  i = _yield$this$_popupHit.queryArea;
                  p = _yield$this$_popupHit.location;
                  a = this._getFetchPopupLayerViews();
                  _this$_graphicsPerFet = this._graphicsPerFetchPopupLayerView(s, a);
                  _t3 = _this$_graphicsPerFet.layerViewsAndGraphics;
                  o = _this$_graphicsPerFet.clientOnlyGraphics;
                  return _context2.abrupt("return", {
                    clientOnlyGraphics: o,
                    layerViewsAndGraphics: _t3,
                    queryArea: i,
                    location: p
                  });

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function _prepareFetchPopupFeatures(_x3, _x4) {
          return _prepareFetchPopupFeatures2.apply(this, arguments);
        }

        return _prepareFetchPopupFeatures;
      }()
    }, {
      key: "_popupHitTestGraphics",
      value: function () {
        var _popupHitTestGraphics2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e, r) {
          var _this = this;

          var _yield$this$popupHitT, s, i, p, a;

          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return this.popupHitTest(e);

                case 2:
                  _yield$this$popupHitT = _context3.sent;
                  s = _yield$this$popupHitT.results;
                  i = _yield$this$popupHitT.mapPoint;
                  p = s.filter(function (e) {
                    return _this._isValidPopupGraphic(e.graphic, r);
                  });
                  a = p.length ? p[0].mapPoint : null;
                  return _context3.abrupt("return", {
                    clientGraphics: p.map(function (e) {
                      return e.graphic;
                    }),
                    queryArea: i,
                    location: i || a
                  });

                case 8:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function _popupHitTestGraphics(_x5, _x6) {
          return _popupHitTestGraphics2.apply(this, arguments);
        }

        return _popupHitTestGraphics;
      }()
    }, {
      key: "_getFetchPopupLayerViews",
      value: function _getFetchPopupLayerViews() {
        var _this2 = this;

        var e = [];
        return this.allLayerViews.forEach(function (r) {
          _this2._isValidPopupLayerView(r) && e.push(r);
        }), s(this.graphicsView) && this._isValidPopupLayerView(this.graphicsView) && e.push(this.graphicsView), e.reverse();
      }
    }, {
      key: "_isValidPopupLayerView",
      value: function _isValidPopupLayerView(e) {
        return s(e) && (!("layer" in e) || !e.suspended) && "fetchPopupFeatures" in e;
      }
    }, {
      key: "_graphicsPerFetchPopupLayerView",
      value: function _graphicsPerFetchPopupLayerView(e, r) {
        var s = [],
            i = new Map(),
            p = r.map(function (e) {
          var r = [];
          return "layer" in e ? i.set(e.layer, r) : i.set(e.graphics, r), {
            layerView: e,
            graphics: r
          };
        });

        var _iterator = _createForOfIteratorHelper(e),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _a2 = _step.value;

            var _e = i.get(_a2.layer) || i.get(_a2.sourceLayer) || null;

            _e ? _e.push(_a2) : s.push(_a2);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return {
          layerViewsAndGraphics: p,
          clientOnlyGraphics: s
        };
      }
    }]);

    return t;
  }(_a3);

  return t = e([p("esri.views.PopupView")], t), t;
};

export { a as PopupView };